import cmp from './HeaderNavigation'

export default cmp
